<script setup>
import { computed, ref, watch, provide } from "vue";
import AssistantMessage from "./AssistantMessage.vue";
import UserMessage from "./UserMessage.vue";
import _reverse from "lodash/reverse";
import _cloneDeep from "lodash/cloneDeep";
import { app } from "@/app.js";
import JsonResponse from "./Components/JsonResponse.vue";
import Suggestion from "./Components/Suggestion.vue";
import SuggestionBox from "./Components/SuggestionBox.vue";
import ImageGeneration from "./Components/ImageGeneration.vue";

const props = defineProps({
    messages: Array,
});

const emit = defineEmits(["suggestion-clicked"]);

app.component("JsonResponse", JsonResponse);
app.component("Suggestion", Suggestion);
app.component("SuggestionBox", SuggestionBox);
app.component("ImageGeneration", ImageGeneration);

const messagesContainer = ref();

// use reversed messages to fix the scroll position
const reversedMessages = computed(() => _reverse(_cloneDeep(props.messages)));

provide("events", {
    "suggestion-clicked": (value) => emit("suggestion-clicked", value),
});

provide("loadedTools", []);

// scroll to bottom when messages are updated
watch(
    () => props.messages,
    () => {
        if (messagesContainer.value !== undefined) {
            messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
        }
    },
    { deep: true, immediate: true }
);
</script>

<template>
    <div class="flex flex-col-reverse space-y-3 space-y-reverse" ref="messagesContainer">
        <template v-for="(message, index) in reversedMessages" :key="reversedMessages.length - index - 1">
            <UserMessage v-if="message.role === 'user'" :message="message.content" :message-index="reversedMessages.length - index - 1" />
            <AssistantMessage
                v-else
                :message="message.content"
                :animate="index === 0"
                @suggestion-clicked="$emit('suggestion-clicked', $event)"
                :message-index="reversedMessages.length - index - 1" />
        </template>
    </div>
</template>
